export default "__VITE_PUBLIC_ASSET__d7cd1ed2__"